import Reflux from "reflux";

var LayoutChooserActions = Reflux.createActions([
  "updateSetting",
  "updateBlock",
  "openDialog",
  "closeDialog",
]);

export default LayoutChooserActions;
